import { useMemo } from 'react';
import FilterTypes from '@constants/FilterTypes';
const useComponentTypeFilters = ({ filters, onFiltersChange, allowedAttachableTypes }) => {
    const handleMultiSelectFilterChange = (fieldName) => {
        return (value) => {
            onFiltersChange(Object.assign(Object.assign({}, filters), { [fieldName]: value }));
        };
    };
    const filtersList = useMemo(() => {
        const list = [];
        // Allowed Attachable Types Filter
        if ((allowedAttachableTypes === null || allowedAttachableTypes === void 0 ? void 0 : allowedAttachableTypes.length) > 0) {
            list.push({
                field: 'allowedAttachableTypes',
                locale: 'allowed_attachable_types',
                type: FilterTypes.GenericMultiSelect,
                active: true,
                value: filters.allowedAttachableTypes || [],
                optionsForSelect: [...allowedAttachableTypes]
                    .sort((a, b) => a.label.localeCompare(b.label))
                    .map((option) => ({
                    title: option.label,
                    value: option.value
                })),
                onChange: handleMultiSelectFilterChange('allowedAttachableTypes')
            });
        }
        return list;
    }, [filters, allowedAttachableTypes, onFiltersChange]);
    return filtersList;
};
export default useComponentTypeFilters;
